import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=9b8533e0&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"
import style0 from "./delivery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b8533e0')) {
      api.createRecord('9b8533e0', component.options)
    } else {
      api.reload('9b8533e0', component.options)
    }
    module.hot.accept("./delivery.vue?vue&type=template&id=9b8533e0&", function () {
      api.rerender('9b8533e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/info/delivery.vue"
export default component.exports